/**
 * 規約・ポリシーの共通レイアウト。
 *
 * 長い文章を読ませる画面なので、アプリの他の画面とは別の作りにする。
 *   - 1 行を読みやすい幅で止める (カードの横幅いっぱいには広げない)
 *   - 条・項の番号は自動で振る (本文に数字を書かない)
 *   - 最終改定日を先頭に出す。改定を追えることが規約では重要
 */
import type { ReactNode } from "react";

export interface LegalDocumentProps {
  title: string;
  /** 最終改定日 (表示用の文字列) */
  updatedOn: string;
  children: ReactNode;
}

export function LegalDocument({ title, updatedOn, children }: LegalDocumentProps) {
  return (
    <article className="card legal">
      <h1 className="legal__title">{title}</h1>
      <p className="legal__updated">最終改定日: {updatedOn}</p>
      {children}
    </article>
  );
}

export interface LegalSectionProps {
  heading: string;
  children: ReactNode;
}

export function LegalSection({ heading, children }: LegalSectionProps) {
  return (
    <section className="legal__section">
      <h2 className="legal__heading">{heading}</h2>
      {children}
    </section>
  );
}
